export default "/assets/images/easy-replacement.webp?9bba4d2fa8c6192afcd28a8947f61434";